import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
  PERMISSION_PRODUCTIONS_READ,
  PERMISSION_TALENTS_READ,
  PERMISSION_VACANCIES_READ
} from '../../constants'
import WithAjax from '../common/helpers/WithAjax'
import {setJumbotronTitle} from '../../actions/common'
import {checkPermission} from '../common/functions/permissions'
import {fetchDashboardSuccess} from '../../actions/pages/dashboard-page'
import IconWidget6 from '../../icon-widgets/IconWidget6'
import GridDashboard from './GridDashboard'

class Dashboard extends Component {
  constructor() {
    super()
    this.state = {
      widgetPendingProfiles: {
        bg: 'warning',
        color: 'white',
        icon: 'done',
        text: 'Pending profiles',
        number: 0,
        url: checkPermission(PERMISSION_TALENTS_READ) ? '/profiles/pending' : null
      },
      widgetActiveProductions: {
        bg: 'success',
        color: 'white',
        icon: 'subscriptions',
        text: 'Active productions',
        number: 0,
        url: checkPermission(PERMISSION_PRODUCTIONS_READ) ? '/productions/active' : null
      },
      widgetPanelSize: {
        bg: 'info',
        color: 'white',
        icon: 'people',
        text: 'Panel size',
        number: 0,
        url: checkPermission(PERMISSION_TALENTS_READ) ? '/talents' : null
      },
      widgetActiveVacancies: {
        bg: 'success',
        color: 'white',
        icon: 'local_offer',
        text: 'Active offers',
        number: 0,
        url: checkPermission(PERMISSION_VACANCIES_READ) ? '/offers/active' : null
      }
    };
  }

  componentDidMount() {
    this.props.setJumbotronTitle('');
    this.fetchDashboardData();
  }

  componentDidUpdate() {
    if (this.props.dashboardData === null && !this.props.isLoading) {
      this.fetchDashboardData();
    }
  }

  fetchDashboardData() {
    this.props.ajax.get('dashboard', true, (data) => {
      this.props.fetchDashboardSuccess(data);
    })
  }

  render() {
    if (this.props.dashboardData === null) {
      return (<div />)
    }

    var widgetPendingProfiles = {...this.state.widgetPendingProfiles}
    widgetPendingProfiles.number = this.props.dashboardData.PendingProfilesNumber;

    var widgetActiveProductions = {...this.state.widgetActiveProductions}
    widgetActiveProductions.number = this.props.dashboardData.ActiveProductionsNumber;

    var widgetPanelSize = {...this.state.widgetPanelSize}
    widgetPanelSize.number = this.props.dashboardData.ActiveSkillVendorsNumber;

    var widgetActiveVacancies = {...this.state.widgetActiveVacancies}
    widgetActiveVacancies.number = this.props.dashboardData.ActiveVacanciesNumber;

    return (
      <div>
        <div className="row">
          <div className="col-6 col-lg-3 mb-1">
            <IconWidget6 {...widgetPanelSize} />
          </div>
          <div className="col-6 col-lg-3 mb-1">
            <IconWidget6 {...widgetPendingProfiles} />
          </div>
          <div className="col-6 col-lg-3 mb-1">
            <IconWidget6 {...widgetActiveProductions} />
          </div>
          <div className="col-6 col-lg-3 mb-1">
            <IconWidget6 {...widgetActiveVacancies} />
          </div>
        </div>
        <GridDashboard/>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  dashboardData: state.dashboardPage.dashboard,
  isLoading: state.common.isLoading
})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle(title) { dispatch(setJumbotronTitle(title)) },
  fetchDashboardSuccess(dashboardData) { dispatch(fetchDashboardSuccess(dashboardData)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(Dashboard))
